import { IModalProvider } from '@base/features/modal/model/interfaces';
import { Subject, BehaviorSubject } from 'rxjs';
import { ModalObservable } from './interfaces';

export default class ModalProvider implements IModalProvider {
  isCloseModal = new BehaviorSubject<boolean>(false);
  onModal = new BehaviorSubject<ModalObservable | undefined>(undefined);
  onTermsAndConditions: Subject<number | undefined> = new Subject();

  showTermsAndConditions(tableId: number) {
    this.onTermsAndConditions.next(tableId);
  }

  hideTermsAndConditions(): void {
    this.onTermsAndConditions.next(undefined);
  }

  show(modal: ModalObservable) {
    this.onModal.next(modal);
  }

  hide() {
    this.isCloseModal.next(true);
    this.onModal.next(undefined);
  }
}
